/* tslint:disable */
/* eslint-disable */
/**
 * Brandside Backend API
 * REST API бэкенда Brandside. Авторизация — Bearer-токен Laravel Passport (заголовок Authorization: Bearer token). Успешные ответы оборачиваются в конверт success_response — status: true, data: ...; ошибки — common_error_response — status: false, errors._common: сообщение.
 *
 * The version of the OpenAPI document: 1.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime'
/**
 * Индивидуальный предприниматель
 * @export
 * @interface IndividualBusinessman
 */
export interface IndividualBusinessman {
  /**
   *
   * @type {string}
   * @memberof IndividualBusinessman
   */
  organizationType: IndividualBusinessmanOrganizationTypeEnum
  /**
   * ИНН заказчика
   * @type {string}
   * @memberof IndividualBusinessman
   */
  inn: string
  /**
   * Наименование заказчика с указанием краткого формата ОПФ
   * @type {string}
   * @memberof IndividualBusinessman
   */
  name: string
  /**
   * Адрес заказчика, с указанием индекса, города, улица и квартиры.
   * @type {string}
   * @memberof IndividualBusinessman
   */
  address: string
  /**
   * Адрес для корреспонденции заказчика. Заказчик может указать адрес в произвольном формате
   * @type {string}
   * @memberof IndividualBusinessman
   */
  addressCorrespondent?: string
}

/**
 * @export
 * @enum {string}
 */
export enum IndividualBusinessmanOrganizationTypeEnum {
  IndividualBusinessman = 'INDIVIDUAL_BUSINESSMAN',
}

/**
 * Check if a given object implements the IndividualBusinessman interface.
 */
export function instanceOfIndividualBusinessman(
  value: object
): value is IndividualBusinessman {
  if (!('organizationType' in value) || value['organizationType'] === undefined)
    return false
  if (!('inn' in value) || value['inn'] === undefined) return false
  if (!('name' in value) || value['name'] === undefined) return false
  if (!('address' in value) || value['address'] === undefined) return false
  return true
}

export function IndividualBusinessmanFromJSON(
  json: any
): IndividualBusinessman {
  return IndividualBusinessmanFromJSONTyped(json, false)
}

export function IndividualBusinessmanFromJSONTyped(
  json: any,
  ignoreDiscriminator: boolean
): IndividualBusinessman {
  if (json == null) {
    return json
  }
  return {
    organizationType: json['organizationType'],
    inn: json['inn'],
    name: json['name'],
    address: json['address'],
    addressCorrespondent:
      json['addressCorrespondent'] == null
        ? undefined
        : json['addressCorrespondent'],
  }
}

export function IndividualBusinessmanToJSON(
  value?: IndividualBusinessman | null
): any {
  if (value == null) {
    return value
  }
  return {
    organizationType: value['organizationType'],
    inn: value['inn'],
    name: value['name'],
    address: value['address'],
    addressCorrespondent: value['addressCorrespondent'],
  }
}
